import {
  DatagridConfigurable,
  List,
  SelectInput,
  SelectArrayInput,
  TextInput,
  TopToolbar,
  FilterButton,
  SelectColumnsButton,
  ExportButton,
} from 'react-admin';
import { columns } from './deadLetterQueueColumns';
import {
  renderGridColumns,
  renderOmitList,
  renderExportColumns,
} from '@/components/ConfigurableColumns';
import { genericCSVExporter } from '@/util/genericCSVExporter';
import { DefaultPagination } from '@/components/DefaultPagination';
import { DeadLetterQueueCommandPanel } from './DeadLetterQueueCommandPanel';
import { useEffect, useMemo } from 'react';

const filters = [
  <TextInput
    key="_id"
    source="_id"
    label="Operation ID"
    defaultValue=""
  />,
  <TextInput
    key="operation"
    source="operation"
    label="Operation"
    defaultValue=""
  />,
  <SelectArrayInput
    key="collectionName"
    label="Entity"
    source="collectionName"
    alwaysOn
    choices={[
      { id: 'therapists', name: 'Therapists' },
      { id: 'therapistSessionNotes', name: 'Session Notes' },
      { id: 'therapistRecordings', name: 'Recordings' },
      { id: 'operationHistory', name: 'Op History' },
      {
        id: 'assetProcessingPipelineLogs',
        name: 'Pipeline Telemetry',
      },
    ]}
  />,

  <TextInput
    key="userId"
    source="userId"
    label="User Id"
    defaultValue=""
  />,
  <TextInput
    key="documentId"
    source="documentId"
    label="Document ID"
    defaultValue=""
  />,
  <SelectInput
    key="result"
    source="result"
    label="Result"
    choices={[
      { id: 'success', name: 'Success' },
      { id: 'failure', name: 'Failure' },
    ]}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <ExportButton
      maxResults={1000000}
      exporter={documentsCsvExporter}
    />
  </TopToolbar>
);

export const DeadLetterQueueList = (props: any) => {
  useEffect(() => {
    console.log('PROPS', props);
  }, [props]);

  const omitList = useMemo(() => renderOmitList(columns), []);

  return (
    <List
      resource="deadLetterQueue"
      perPage={25}
      filters={filters}
      sort={{ field: 'when', order: 'DESC' }}
      actions={<ListActions />}
      pagination={<DefaultPagination />}
      queryOptions={{
        meta: {
          facet: false,
        },
      }}
    >
      <DatagridConfigurable
        bulkActionButtons={false}
        omit={omitList}
        expand={DeadLetterQueueCommandPanel}
      >
        {renderGridColumns(columns)}
      </DatagridConfigurable>
    </List>
  );
};

const documentsCsvExporter = genericCSVExporter(
  'deadLetterQueue',
  renderExportColumns(columns),
);
